import { useState } from 'react';

const PRIVACY_TEXT = `Informativa sul trattamento dei dati personali
ai sensi dell'art. 13 del Reg. (UE) n. 2016/679

Ai sensi dell'art. 13 del Regolamento (UE) n. 2016/679 (di seguito il "GDPR"), LA.RA. SERVICE SRL (di seguito il "Titolare") La informa che i Suoi dati personali (di seguito i "Dati"), raccolti presso di Lei o presso terzi, saranno trattati nel rispetto di quanto previsto dal GDPR e in conformità all'informativa che segue.

Titolare del trattamento. Responsabili del trattamento.
Il Titolare del trattamento dei Dati è LA.RA. SERVICE SRL con sede in Toscana, Italia. Telefono: 0574 1640031; email: infolaraservice@gmail.com. L'elenco aggiornato degli eventuali responsabili del trattamento è disponibile presso la sede del Titolare.

Responsabile protezione dei dati.
Il Responsabile della protezione dei dati è contattabile a: infolaraservice@gmail.com

Finalità e base giuridica del trattamento. Legittimi interessi perseguiti.
I Dati saranno trattati per le seguenti finalità: gestione delle richieste di contatto e preventivo, fornitura dei servizi richiesti, adempimento di obblighi contrattuali e precontrattuali, adempimento di obblighi di legge.

Destinatari o categorie di destinatari.
I Dati potranno essere resi accessibili, portati a conoscenza di o comunicati ai seguenti soggetti, i quali saranno nominati dal Titolare, a seconda dei casi, quali Responsabili o agiranno in qualità di titolari autonomi: fornitori di servizi IT e di comunicazione, consulenti e professionisti. In ogni caso, i Dati non saranno diffusi.

Trasferimento dei Dati a paesi terzi.
I dati circoleranno nell'ambito di paesi appartenenti all'UE. I Dati, inoltre, potranno essere comunicati alle società controllate dal Titolare, ovvero dalle società affiliate al Titolare, situate in paesi non appartenenti all'Unione Europea, occasionalmente ed esclusivamente nel caso in cui il trasferimento sia necessario all'esecuzione di un contratto concluso con l'interessato e il titolare del trattamento, ovvero all'esecuzione di misure precontrattuali adottate su istanza dell'interessato (art. 49, comma 2, lett. b)).

Periodo di conservazione.
I dati saranno conservati per un periodo di tempo massimo pari al periodo di prescrizione dei diritti azionabili dal Titolare, come di volta in volta applicabile.

Diritti di accesso, cancellazione, limitazione e portabilità.
Agli interessati sono riconosciuti i diritti di cui agli artt. da 15 a 20 del GDPR. A titolo esemplificativo, ciascun interessato potrà:
a) ottenere la conferma che sia o meno in corso un trattamento di dati personali che lo riguardano;
b) qualora un trattamento sia in corso, ottenere l'accesso ai dati personali e alle informazioni relative al trattamento nonché richiedere una copia dei dati personali;
c) ottenere la rettifica dei dati personali inesatti e l'integrazione dei dati personali incompleti;
d) ottenere, qualora sussista una delle condizioni previste dall'art. 17 del GDPR, la cancellazione dei dati personali che lo riguardano;
e) ottenere, nei casi previsti dall'art. 18 del GDPR, la limitazione del trattamento;
f) ricevere i dati personali che lo riguardano in un formato strutturato, di uso comune e leggibile da dispositivo automatico e richiedere la loro trasmissione ad un altro titolare, se tecnicamente fattibile.

Diritto di opposizione.
Ciascun interessato ha il diritto di opporsi in qualsiasi momento al trattamento dei suoi dati personali effettuato per il perseguimento di un legittimo interesse del Titolare. In caso di opposizione, i suoi dati personali non saranno più oggetto di trattamento, sempre che non sussistano motivi legittimi per procedere al trattamento che prevalgono sugli interessi, sui diritti e sulle libertà dell'interessato oppure per l'accertamento, l'esercizio o la difesa di un diritto in sede giudiziaria.

Diritto di revoca del consenso.
Nel caso in cui sia richiesto il consenso per il trattamento dei dati personali, ciascun interessato potrà, altresì, revocare in qualsiasi momento il consenso già prestato, senza pregiudicare la liceità del trattamento basata sul consenso prestato prima della revoca.

Diritto di proporre reclamo al Garante.
Inoltre ciascun interessato potrà proporre reclamo al Garante per la Protezione dei Dati Personali nel caso in cui ritenga che siano stati violati i diritti di cui è titolare ai sensi del GDPR, secondo le modalità indicate sul sito internet del Garante accessibile all'indirizzo: www.garanteprivacy.it.

Diritti dell'interessato.
I diritti dell'interessato potranno essere esercitati tramite i recapiti di riferimento sopra indicati.`;

export default function Contact() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefono: '',
    azienda: '',
    servizio: '',
    messaggio: ''
  });
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!privacyAccepted) return;
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });
      formBody.append('privacy_accettata', 'true');

      const response = await fetch('https://readdy.ai/api/form/d6a5aa7mvg9ih2c7ab0g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          telefono: '',
          azienda: '',
          servizio: '',
          messaggio: ''
        });
        setPrivacyAccepted(false);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contatti" className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            Contattaci
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Richiedi un preventivo o maggiori informazioni sui nostri servizi. Il nostro team è a tua disposizione
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <form id="contact_form" onSubmit={handleSubmit} data-readdy-form className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="nome" className="block text-sm font-medium text-slate-700 mb-2">
                    Nome e Cognome *
                  </label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    required
                    value={formData.nome}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-slate-700 focus:border-transparent text-sm"
                    placeholder="Mario Rossi"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-slate-700 focus:border-transparent text-sm"
                    placeholder="mario.rossi@email.it"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="telefono" className="block text-sm font-medium text-slate-700 mb-2">
                    Telefono
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-slate-700 focus:border-transparent text-sm"
                    placeholder="+39 123 456 7890"
                  />
                </div>
                <div>
                  <label htmlFor="azienda" className="block text-sm font-medium text-slate-700 mb-2">
                    Azienda
                  </label>
                  <input
                    type="text"
                    id="azienda"
                    name="azienda"
                    value={formData.azienda}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-slate-700 focus:border-transparent text-sm"
                    placeholder="Nome Azienda"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="servizio" className="block text-sm font-medium text-slate-700 mb-2">
                  Servizio di Interesse *
                </label>
                <select
                  id="servizio"
                  name="servizio"
                  required
                  value={formData.servizio}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-slate-700 focus:border-transparent text-sm"
                >
                  <option value="">Seleziona un servizio</option>
                  <option value="Lavorazioni Meccaniche">Lavorazioni Meccaniche</option>
                  <option value="Ferro per Edilizia">Ferro per Edilizia</option>
                  <option value="Strutture Metalliche">Strutture Metalliche</option>
                  <option value="Supporto Tecnico">Supporto Tecnico</option>
                  <option value="Altro">Altro</option>
                </select>
              </div>

              <div>
                <label htmlFor="messaggio" className="block text-sm font-medium text-slate-700 mb-2">
                  Messaggio *
                </label>
                <textarea
                  id="messaggio"
                  name="messaggio"
                  required
                  rows={5}
                  maxLength={500}
                  value={formData.messaggio}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-slate-700 focus:border-transparent text-sm resize-none"
                  placeholder="Descrivi la tua richiesta..."
                ></textarea>
                <p className="text-xs text-slate-500 mt-1">Massimo 500 caratteri</p>
              </div>

              {/* Privacy Checkbox */}
              <div className="flex items-start gap-3 p-4 bg-slate-50 rounded-lg border border-slate-200">
                <input
                  type="checkbox"
                  id="privacy"
                  name="privacy_accettata"
                  checked={privacyAccepted}
                  onChange={(e) => setPrivacyAccepted(e.target.checked)}
                  required
                  className="mt-0.5 w-4 h-4 accent-slate-700 cursor-pointer flex-shrink-0"
                />
                <label htmlFor="privacy" className="text-sm text-slate-600 cursor-pointer leading-relaxed">
                  Ho letto e accetto l&apos;
                  <button
                    type="button"
                    onClick={() => setShowPrivacyModal(true)}
                    className="text-slate-800 font-semibold underline underline-offset-2 hover:text-slate-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Informativa sul trattamento dei dati personali
                  </button>
                  {' '}ai sensi dell&apos;art. 13 del Reg. (UE) n. 2016/679. *
                </label>
              </div>

              <button
                type="submit"
                disabled={isSubmitting || !privacyAccepted}
                className="w-full bg-gradient-to-r from-slate-700 to-slate-900 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:from-slate-800 hover:to-slate-950 transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Invio in corso...' : 'Invia Richiesta'}
              </button>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg">
                  Grazie! La tua richiesta è stata inviata con successo. Ti contatteremo presto.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg">
                  Si è verificato un errore. Riprova più tardi.
                </div>
              )}
            </form>
          </div>

          <div className="space-y-8">
            <div className="bg-gradient-to-br from-slate-700 to-slate-900 rounded-2xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-6">Informazioni di Contatto</h3>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Sede Operativa</h4>
                    <p className="text-white/80">Toscana, Italia</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-phone-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Telefono</h4>
                    <p className="text-white/80">0574 1640031</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-mail-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Email</h4>
                    <p className="text-white/80">infolaraservice@gmail.com</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-time-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Orari</h4>
                    <p className="text-white/80">Lun - Ven: 8:00 - 18:00</p>
                    <p className="text-white/80">Sab: 8:00 - 13:00</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-slate-50 rounded-2xl p-8">
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Perché Sceglierci</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-check-line text-slate-700 text-xl mr-3 mt-1"></i>
                  <span className="text-slate-700">Esperienza consolidata nel settore</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-slate-700 text-xl mr-3 mt-1"></i>
                  <span className="text-slate-700">Lavorazioni di alta precisione</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-slate-700 text-xl mr-3 mt-1"></i>
                  <span className="text-slate-700">Consegne puntuali garantite</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-slate-700 text-xl mr-3 mt-1"></i>
                  <span className="text-slate-700">Supporto tecnico personalizzato</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-slate-700 text-xl mr-3 mt-1"></i>
                  <span className="text-slate-700">Copertura nazionale</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      {showPrivacyModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowPrivacyModal(false); }}
        >
          <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col">
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
              <h3 className="text-lg font-bold text-slate-900">Informativa sul trattamento dei dati personali</h3>
              <button
                type="button"
                onClick={() => setShowPrivacyModal(false)}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 transition-colors cursor-pointer text-slate-500"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="overflow-y-auto px-6 py-5 flex-1">
              <p className="text-xs text-slate-500 mb-4 font-medium">ai sensi dell&apos;art. 13 del Reg. (UE) n. 2016/679</p>
              <div className="text-sm text-slate-700 leading-relaxed whitespace-pre-line">
                {PRIVACY_TEXT}
              </div>
            </div>
            <div className="px-6 py-4 border-t border-slate-200 flex gap-3 justify-end">
              <button
                type="button"
                onClick={() => setShowPrivacyModal(false)}
                className="px-5 py-2 rounded-lg border border-slate-300 text-slate-700 text-sm font-medium hover:bg-slate-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                Chiudi
              </button>
              <button
                type="button"
                onClick={() => { setPrivacyAccepted(true); setShowPrivacyModal(false); }}
                className="px-5 py-2 rounded-lg bg-slate-800 text-white text-sm font-medium hover:bg-slate-900 transition-colors cursor-pointer whitespace-nowrap"
              >
                Ho letto e accetto
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}